<template>
    <div class="container-fluid container-fill">
        <div class="row">
            <div class="paper">
                <h2>
                    <router-link to="/Admin"><font-awesome-icon :icon="['fa', 'arrow-left']" class="pointer olive-green-text" /></router-link>
                    Distribution List
                    <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer" style="margin-right:0.5rem;" />
                    <font-awesome-icon :icon="['fa', 'plus']" class="pointer olive-green-text " @click="CreateDistributionListButton" />
                    <span class="AddOrEditModal">

                        <b-modal ref="component-modal" title="Add or Edit Distribution List" hide-footer>
                            <b-container fluid>
                                <b-form @submit="AddOrEditDistributionList">
                                    <b-row>
                                        <b-col cols="12"><b>Name:</b></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="name" type="name" required></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12"><b>Description:</b></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-textarea rows="3" v-model="description" required></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12"><b>Current Emails:</b></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-textarea rows="3" v-model="recipients" required></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12"><b>Subprogram Specifier:</b></b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subprogramSpecifier" type="name"></b-col>
                                    </b-row>
                                    <b-row class="modal-btn-row">
                                        <div class="modal-btn-row-div">
                                            <b-button size="md" variant="secondary" @click="Cancel()">
                                                CANCEL
                                            </b-button>
                                            <b-button size="md" variant="primary" type="submit">
                                                CONFIRM
                                            </b-button>
                                        </div>
                                    </b-row>
                                </b-form>
                            </b-container>
                        </b-modal>
                    </span>
                </h2>
                <vuetable :fields="DistributionListTableOptions.Fields"
                          :data-manager="DataManager"
                          pagination-path=""
                          :api-mode="false"
                          ref="datatable">
                    <template slot="DistributionListActions" scope="props">
                        <div class="DistributionListActionsDiv">
                            <b-row no-gutters>
                                <b-col md="auto">
                                    <font-awesome-icon :icon="['fa', 'edit']" style="font-size: 24px; margin-right:1rem;" class="pointer orange " @click="EditDistributionListButton(props.rowData)" />
                                </b-col>
                                <b-col md="auto">
                                    <ActionButtonWithIcon :requires-confirmation="true"
                                                          confirmation-string="WARNING: You are about to delete this distribution list.  Are you sure?"
                                                          endpoint="DistributionList/DeleteDistributionList"
                                                          :payload="{Id: props.rowData.Id}"
                                                          :perform-global-update="false"
                                                          button-variant="success"
                                                          button-string=""
                                                          button-size="md"
                                                          v-on:success="RefreshDataTable"
                                                          icon-prefix="fa"
                                                          icon-suffix="trash-alt"
                                                          icon-color="red"
                                                          method="POST"/>
                                </b-col>
                            </b-row>
                        </div>
                    </template>
                </vuetable>
            </div>
        </div>
    </div>
</template>

<script>
    //import components
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    // import helper functions
    import ActionButtonWithIcon from '../Admin/ActionButtonWithIcon.vue';
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowLeft);
    import { EventBus } from '../../services/event-bus.js';
    export default {
        name: "DistributionList",
        created() {
        },
        props: [],
        data: function () {
            return {
                name: '',
                description: '',
                recipients: '',
                DistributionLists: [],
                Id: '',
                subprogramSpecifier: '',
                DistributionListTableOptions: {
                    Fields: [
                        {
                            name: 'Name',
                            title: 'Name',
                            sortField: 'Name'
                        },
                        {
                            name: 'Description',
                            title: 'Description',
                            sortField: 'Description'
                        },
                        {
                            name: 'Recipients',
                            title: 'Recipients',
                            sortField: 'Recipients'
                        },
                        {
                            name: 'SubProgramSpecifier',
                            title: 'SubProgram Specifier',
                            sortField: 'SubProgramSpecifier'
                        },
                        {
                            name: '__slot:DistributionListActions',
                            title: 'Actions'
                        }
                    ]
                }
            };
        },
        methods: {
            EditDistributionListButton(rowData) {
                this.Id = rowData.Id;
                this.name = rowData.Name;
                this.description = rowData.Description;
                this.recipients = rowData.Recipients;
                this.subprogramSpecifier = rowData.SubProgramSpecifier;
                this.$refs['component-modal'].show();
            },
            CreateDistributionListButton(rowData) {
                this.Id = "";
                this.name = "";
                this.description = "";
                this.recipients = "";
                this.subprogramSpecifier = "";
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            RefreshDataTable() {
                this.GetDistributionLists();
            },
            GetDistributionLists() {
                this.$MasterAPI.ExecuteRequest("GET", "DistributionList/GetDistributionLists", {}, this.GetDistributionListsSuccess, () => { }, true);
            },
            GetDistributionListsSuccess(response) {
                this.DistributionLists = response.data.data;
                this.$refs.datatable.refresh();
            },
            AddOrEditDistributionList(e) {
                e.preventDefault();
                if (this.Id == "") {
                    this.$MasterAPI.ExecuteRequest("POST", "DistributionList/CreateDistributionList", { Name: this.name, Description: this.description, Recipients: this.recipients, SubProgramSpecifier: this.subprogramSpecifier }, this.AddOrEditDistributionListSuccess, () => { }, true);
                }
                
                else {
                    this.$MasterAPI.ExecuteRequest("POST", "DistributionList/EditDistributionList", { Id: this.Id, Name: this.name, Description: this.description, Recipients: this.recipients, SubProgramSpecifier: this.subprogramSpecifier }, this.AddOrEditDistributionListSuccess, () => { }, true);
                }
            },
            AddOrEditDistributionListSuccess(response){
                this.RefreshDataTable();
                this.$refs["component-modal"].hide();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.DistributionLists);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    visibleData.push(inputData[index]);
                });
                return visibleData;
            },
        },
        components: {
            ActionButtonWithIcon,
            Vuetable
        },
        computed: {
           
        },
        mounted() {
            this.GetDistributionLists();
        }
    }
</script>

<style scoped>
</style>